import React from 'react'
import { Link } from 'react-router-dom';

import cat1 from '../images/A.S FLUTE-01.png'
import cat2 from '../images/A.S FLUTE-02.png'
import cat3 from '../images/A.S FLUTE-03.png'
import cat4 from '../images/A.S FLUTE-04.png'

import cat5 from '../images/A.S LOUVERS-01.png'
import cat6 from '../images/A.S LOUVERS-02.png'
import cat7 from '../images/A.S LOUVERS-03.png'
import cat8 from '../images/A.S LOUVERS-04.png'

const Productcatogory = () => {
    return (
        <div className='productcatogorey'>

            <br />
            <h2 className='text-center text-white '> OUR CATEGORY</h2>

            <div className='product2'>

                <div className='product3'>
                    <img src={cat1} />
                </div>

                <div className='product3'>
                    <img src={cat2} />
                </div>

                <div className='product3'>
                    <img src={cat3} />
                </div>

                <div className='product3'>
                    <img src={cat4} />
                </div>

            </div>
            <div className='product2'>

                <div className='product3'>
                    <img src={cat5} />
                </div>

                <div className='product3'>
                    <img src={cat6} />
                </div>

                <div className='product3'>
                    <img src={cat7} />
                </div>

                <div className='product3'>
                    <img src={cat8} />
                </div>

            </div>

            <br />

            <center>
                <Link
                    to="/Catogery"
                    className="custom-btn custom-btn-outline-white"
                    aria-label="Learn more about our interior design products and services"
                >
                    Learn More
                </Link>
            </center>


            <br />
        </div>
    )
}

export default Productcatogory